/**
 * Include modules
 */
import {setFilePlaylist} from './modules/filePlaylist.js';
import {getFormattedCurrentTime, setFormatTime} from './modules/formatTime.js';
import {setStreamingPlaylist} from './modules/extConcat.js';

/**
 * Entry point class (main)
 */
export default class RaiVideoPlayer{
 
    /**
     * Html ID
     */
    videoPlayerIdElement="";

    /**
     * Class Options
     */
    videoPlayerOptions={}

    /**
     * Video.Js instance
     */
    videoPlayerJsInstance=null;

    /**
     * 
     * @param {string} idElement 
     * @param {object} options 
     * @returns 
     */
    constructor(videojs,idElement,options){
        //set the container and options
        this.videoPlayerIdElement=idElement;
        this.videoPlayerOptions=options;

        //set the options
        this.#setVideoPlayerOptions(videojs);
        //istantiate videojs
        this.videoPlayerJsInstance=videojs(idElement,options);
        //return the videojs istance
        return {
            videojs:this.videoPlayerJsInstance, //original Video.Js instance
            extensions:this.#addNewMethods(this.videoPlayerJsInstance) //extensions methos and properties
        }
    }

    /**
     * Set the options to the video player
     * @param {object} videojs 
     */
    #setVideoPlayerOptions(videojs){
        //setFormatTime
        if(
            this.videoPlayerOptions["setFormatTime"] !== undefined &&
            this.videoPlayerOptions["setFormatTime"].start !== undefined
        ){
            let start=(this.videoPlayerOptions["setFormatTime"].start !== undefined ? this.videoPlayerOptions["setFormatTime"].start : 0);
            let format=(this.videoPlayerOptions["setFormatTime"].format !== undefined ? this.videoPlayerOptions["setFormatTime"].format : "H:i:s");
            //set the new format time
            setFormatTime(videojs,start,format);
        }
    }

    /**
     * Add new methods to the wrapper
     * @param {object} videojs 
     * @param {object} params 
     * @returns 
     */
    #addNewMethods(videojs){
        return {
            getFormattedCurrentTime: function(){return getFormattedCurrentTime()},
            setFilePlaylist: function(videoJsWrapper,playlist){return setFilePlaylist(videoJsWrapper,playlist)},
            setStreamingPlaylist: function(videoJsWrapper,playlist){return setStreamingPlaylist(videoJsWrapper,playlist)}
        }
    }
}

